import { useState } from 'react';
import clsx from 'clsx';

import { SearchParamType, useNavigation } from '@atom/hooks/useNavigation';
import { AssetSidebar, UserSidebar, WorkOrderSidebar } from '@atom/map';
import { Icon } from '@atom/mui';
import { ArrowDropDownIcon } from '@atom/mui/icons';

import FilterPanel from './filterPanel/FilterPanel';
import KmlSidebar from './kml/KmlSidebar';
import ListView from './list/ListView';

import classes from './mapPortal.module.css';

const Drawer = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [{ view, id }, { updateSearchParams }] = useNavigation({
    view: SearchParamType.STRING,
    id: SearchParamType.STRING,
  });

  const handleClose = () => {
    updateSearchParams({ view: 'list', id: null });
  };

  const renderContent = () => {
    if (collapsed) {
      return null;
    }

    switch (view) {
      case 'layers':
        return <FilterPanel />;
      case 'list':
        return <ListView />;
      case 'asset':
        return <AssetSidebar id={id} onClose={handleClose} />;
      case 'workOrder':
        return <WorkOrderSidebar id={id} onClose={handleClose} />;
      case 'user':
        return <UserSidebar id={id} onClose={handleClose} />;
      case 'kml':
        return <KmlSidebar />;
      default:
        return null;
    }
  };

  return (
    <div className={classes.drawer}>
      <div
        className={clsx(
          classes.drawerContent,
          collapsed && classes.drawerContentCollapsed,
        )}
      >
        {renderContent()}
      </div>
      <div
        className={classes.drawerArrow}
        onClick={() => setCollapsed(!collapsed)}
      >
        <Icon
          className={collapsed ? classes.arrowCollapsed : classes.arrowExpanded}
          icon={ArrowDropDownIcon}
        />
      </div>
    </div>
  );
};

export default Drawer;
